import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  itemBox: {
    padding: 12,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    cursor: 'pointer',
    transition: 'all 0.25s linear',
    position: 'relative',
    height: 'fit-content'
  },
  disabled: {
    opacity: '50%'
  },
  errorBox: {
    border: `1px solid ${theme.palette.error.main}`,
    borderRadius: 3
  },
  skeleton: {
    width: '60%',
    height: 30
  },
  skeletonName: {
    width: '30%',
    height: 20
  },
  Subskeleton: {
    width: '60%',
    height: 30,
    left: -50
  },
  skeletonContainer: {
    width: '100%',
    height: 60,
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center'
  },
  codeMappingContianer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    },
    '& > div:first-child': {
      marginLeft: -11,
      marginBottom: -2
    },
    '& svg': {
      // marginLeft: -55,
      // marginRight: 65,
      // marginBottom: -25
    },
    '&  div:last-child': {
      '& input': {
        height: '27px !important',
        borderRadius: '4px !important'
      },
      '& > div:first-child': {
        '& > div:first-child': {
          marginLeft: -12
        }
      }
    },
    '& div:nth-last-child(2)': {
      marginBottom: 0
    }
  },
  title: {
    marginBottom: 15,
    fontSize: 18,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    }
  },
  button: {
    display: 'flex',
    position: 'absolute',
    right: 0,
    top: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '65%',
      opacity: 0.01
    }
  },
  btn: {
    backgroundColor: theme.palette.grey[300],
    '& p': { color: theme.palette.grey[800] }
  },
  LeftIcon: {
    rotate: '180deg'
  },
  iconContainer: {
    marginRight: 105
  }
}))

export default useStyles
